import * as React from 'react'

import { Form as FactorialForm } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import TextArea from 'modules/core/components/Inputs/TextArea'
import i18n from 'modules/core/lib/i18n'

export class DashboardForm extends FactorialForm {
  constructor(values: {}) {
    super(values, {
      title: 'string',
      description: 'string',
    })
    makeObservable(this, {
      isCompleted: computed,
    })
  }

  get isCompleted(): boolean {
    return !!this.get('title').value?.length
  }
}
interface Props {
  form: DashboardForm
}

const DashboardFormComponent = ({ form }: Props) => {
  return (
    <>
      <FormRow>
        <Text label={i18n.t('common.title')} field={form.get('title')} />
      </FormRow>
      <FormRow>
        <TextArea label={i18n.t('common.description')} field={form.get('description')} />
      </FormRow>
    </>
  )
}

export default observer(DashboardFormComponent)
